// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-input[data-v-1ee624f8] {\n  width: 250px;\n}\n.dialog-footer[data-v-1ee624f8] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.dialog-footer-tail[data-v-1ee624f8] {\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
